import { BillViewOptions } from "@common/types/bill";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

export function useBillsPageViewOptionsCache(): [
    BillViewOptions | undefined,
    (value: BillViewOptions | undefined) => void,
] {
    const [value, setter] = useWorkspaceUserCache<BillViewOptions>(
        WORKSPACE_USER_CACHE_KEYS.BILLS_PAGE_VIEW_OPTIONS_CACHE_KEY,
    );

    return [
        value,
        (viewOptions: BillViewOptions | undefined) => {
            setter(viewOptions);
        },
    ];
}
